import { cx } from '@linaria/core';
import { NotificationCount } from '@pm2/react-utils';
import { DialogIcon } from '@ui/kit/icons';
import { icon, badge, wrapper } from './icon.dialog.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function EntriesDialogIcon(props) {
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.hidden && "hidden"),
    children: [/*#__PURE__*/jsx(DialogIcon, {
      className: icon,
      height: props.height
    }), /*#__PURE__*/jsx(NotificationCount, {
      active: props.hasNewNotifications ?? false,
      className: badge
    })]
  });
}

export { EntriesDialogIcon };
//# sourceMappingURL=icon.dialog.js.map
